import React from "react";
import { Modal, Typography, Button, Flex } from "antd";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

const { Text, Title } = Typography;

interface DownloadModalProps {
  open: boolean;
  onCancel: () => void;
  onDownload: () => void;
  isLoading?: boolean;
  isMeshRoute?: boolean;
}

const SpecimenDownloadModal: React.FC<DownloadModalProps> = ({
  open,
  onCancel,
  onDownload,
  isLoading = false,
  isMeshRoute = false,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width={600}
      centered
      closeIcon={null}
    >
      <Flex vertical gap="16px" className="py-2">
        <Title
          level={4}
          style={{
            margin: 0,
            fontSize: "24px",
            fontWeight: 500,
          }}
        >
          1 Image selected for download
        </Title>

        <Flex vertical gap="8px" className="text-base">
          <Text className="font-medium">Image download bundle includes:</Text>
          <ul className="list-disc m-0 pl-6 space-y-1">
            {!isMeshRoute && <li>Raw image file of the individual mosquito</li>}
            <li>
              Raw image file of the{" "}
              {isMeshRoute ? "mesh" : "corresponding mesh"}
            </li>
            <li>CSV file with all text metadata</li>
          </ul>
        </Flex>

        <Flex justify="flex-end" gap="16px" className="mt-4">
          <Button
            type="text"
            className="font-medium text-base hover:bg-transparent"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="flex items-center gap-2 bg-[#0ea5e9] hover:bg-[#0284c7] border-none text-base h-10 px-4"
            onClick={onDownload}
            loading={isLoading}
          >
            <ArrowDownTrayIcon className="w-5 h-5" />
            Download
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default SpecimenDownloadModal;
